export default __webpack_public_path__ + "4bbf0900ad17e3cfceea866879cd08f0.svg";